import { __decorate, __extends } from "tslib";
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
function CountdownTracker(label, value) {
    var el = document.createElement("span");
    el.className = "flip-clock__piece";
    el.innerHTML = '<b class="flip-clock__card card"><b class="card__top"></b><b class="card__bottom"></b><b class="card__back"><b class="card__bottom"></b></b></b>' + '<span class="flip-clock__slot">' + label + "</span>";
    //@ts-ignore
    this.el = el;
    var top = el.querySelector(".card__top"), bottom = el.querySelector(".card__bottom"), back = el.querySelector(".card__back"), backBottom = el.querySelector(".card__back .card__bottom");
    //@ts-ignore
    this.update = function (val) {
        val = ("0" + val).slice(-2);
        if (val !== this.currentValue) {
            if (this.currentValue >= 0) {
                back.setAttribute("data-value", this.currentValue);
                bottom.setAttribute("data-value", this.currentValue);
            }
            this.currentValue = val;
            //@ts-ignore
            top.innerText = this.currentValue;
            backBottom.setAttribute("data-value", this.currentValue);
            this.el.classList.remove("flip");
            void this.el.offsetWidth;
            this.el.classList.add("flip");
        }
    };
    //@ts-ignore
    this.update(value);
}
function getTimeRemaining(endtime, language, days) {
    //@ts-ignore
    var t = Date.parse(endtime) - Date.parse(new Date());
    if (!days) {
        if (language == "fr") {
            return {
                Total: t,
                Heures: Math.floor((t / (1000 * 60 * 60))),
                Minutes: Math.floor((t / 1000 / 60) % 60),
                Secondes: Math.floor((t / 1000) % 60),
            };
        }
        else {
            return {
                Total: t,
                Stunden: Math.floor((t / (1000 * 60 * 60))),
                Minuten: Math.floor((t / 1000 / 60) % 60),
                Sekunden: Math.floor((t / 1000) % 60),
            };
        }
    }
    else {
        if (language == "fr") {
            return {
                Total: t,
                Jours: Math.floor(t / (1000 * 60 * 60 * 24)),
                Heures: Math.floor((t / (1000 * 60 * 60)) % 24),
                Minutes: Math.floor((t / 1000 / 60) % 60),
                Secondes: Math.floor((t / 1000) % 60),
            };
        }
        else {
            return {
                Total: t,
                Tage: Math.floor(t / (1000 * 60 * 60 * 24)),
                Stunden: Math.floor((t / (1000 * 60 * 60)) % 24),
                Minuten: Math.floor((t / 1000 / 60) % 60),
                Sekunden: Math.floor((t / 1000) % 60),
            };
        }
    }
}
function Clock(countdown, language, callback, days) {
    countdown = countdown ? new Date(Date.parse(countdown)) : false;
    callback = callback || function () { };
    //@ts-ignore
    this.el = document.createElement("div");
    //@ts-ignore
    this.el.className = "flip-clock";
    var trackers = {}, t = getTimeRemaining(countdown, language, days), key, timeinterval;
    for (key in t) {
        if (key === "Total") {
            continue;
        }
        trackers[key] = new CountdownTracker(key, t[key]);
        //@ts-ignore
        this.el.appendChild(trackers[key].el);
    }
    var i = 0;
    function updateClock() {
        timeinterval = requestAnimationFrame(updateClock);
        // throttle so it's not constantly updating the time.
        if (i++ % 10) {
            return;
        }
        var t = getTimeRemaining(countdown, language, days);
        if (t.Total < 0) {
            cancelAnimationFrame(timeinterval);
            for (key in trackers) {
                trackers[key].update(0);
            }
            callback();
            return;
        }
        for (key in trackers) {
            trackers[key].update(t[key]);
        }
    }
    setTimeout(updateClock, 500);
}
var CouponCountdown = /** @class */ (function (_super) {
    __extends(CouponCountdown, _super);
    function CouponCountdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CouponCountdown.prototype.mounted = function () {
        //@ts-ignore
        var c = new Clock(this.deadline, this.language, this.days);
        //@ts-ignore
        this.$refs.lturCouponCountdown.appendChild(c.el);
    };
    __decorate([
        Prop()
    ], CouponCountdown.prototype, "deadline", void 0);
    __decorate([
        Prop()
    ], CouponCountdown.prototype, "language", void 0);
    __decorate([
        Prop({ default: true })
    ], CouponCountdown.prototype, "days", void 0);
    CouponCountdown = __decorate([
        Component
    ], CouponCountdown);
    return CouponCountdown;
}(Vue));
export default CouponCountdown;
